module.exports = __webpack_public_path__ + "img/img-2.1c4b30e8.jpg";